import React, { Component } from 'react';
import { history } from 'components/App/components/UnauthenticatedApp';
import './PasswordForgot.module.scss';
import { connect } from 'react-redux';

//import components
import DefaultButton from 'components/UI/Button/Button';

import forgotPassword from 'actions/password/forgot';

const mapDispatchToProps = {
    forgotPassword
};

class PasswordForgot extends Component {

    constructor(props) {
        super(props);

        this.state = {
            email: '',
        };

        this.resetPassword = this.resetPassword.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        
    }

    componentDidMount() {
        
    }

    resetPassword() {

        this.props.forgotPassword(this.state)
            .then((result) => {
                return alert('Je ontvangt nu een email met instructies om je wachtwoord in te stellen.');
            })
            .catch((error) => {
                return alert('Er ging iets mis met het herstellen van uw wachtwoord, probeer aub opnieuw.');
            });
    }

    handleEmailChange(event) {
        this.setState({ email: event.target.value });
    }

    goToLogin() {
        history.push('/inloggen');
    }

    render() {
        return (
            <div styleName="login-background">
                <div styleName="top-bar">
                    <img style={{ cursor:'pointer' }} onClick={() => {history.push('/');}} styleName="logo" src='/images/logos/plenda-logo.svg' />
                </div>
                <div styleName="content">
                    <img styleName="mountains-logo" src="/images/mountains.svg" />
                    <h1>Wachtwoord instellen</h1>
                    <p>Ben je je wachtwoord vergeten of wil je een wachtwoord aanmaken? Vul je emailadres in en je ontvangt instructies om een nieuw wachtwoord in te stellen.</p>
                    <form styleName="login-form">
                        <label styleName="input-label">Emailadres</label>
                        <input value={this.state.email} onChange={this.handleEmailChange} styleName="input-box" type="email" />
                    </form>
                    <div styleName="actions">
                        <div styleName="text">
                            <p styleName="link" onClick={this.goToLogin}>Naar inlogpagina</p>
                        </div>
                        <DefaultButton handleClick={this.resetPassword} noarrow style={{ marginTop: '9px', width: '73px', borderRadius: '3px' }} title="Verzenden" type="blue" />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, mapDispatchToProps)(PasswordForgot);